let counter = 0;

/** A short unique id, good enough for local data. */
export function newId(): string {
  counter += 1;
  const rand = Math.random().toString(36).slice(2, 8);
  return `${Date.now().toString(36)}-${counter.toString(36)}-${rand}`;
}
